import React from 'react';
import { businessStats } from '../mock';

export default function StatsBand() {
  return (
    <section className="py-14 lg:py-16" style={{ backgroundColor: 'var(--forest-deep)' }} data-testid="stats-band">
      <div className="container-x">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-10 gap-x-6">
          {businessStats.map((s) => (
            <div key={s.label} className="text-center reveal" data-testid={`stat-${s.value}`}>
              <div
                className="font-serif-display leading-none"
                style={{ color: 'var(--sage)', fontSize: 'clamp(2.4rem, 4vw, 3.4rem)' }}
              >
                {s.value}
              </div>
              <div className="mt-3 text-[13px] sm:text-sm tracking-wide" style={{ color: 'rgba(255,255,255,0.72)' }}>
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
